<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <transition name="modal">
    <div class="modal-wrapper" data-testid="notification-modal">
      <div class="modal-container">
        <div
          class="modal-item"
          @click.stop="handleReadNotification"
          data-testid="notification-mark-read"
        >
          Mark as read
        </div>
        <div
          class="modal-item"
          @click.stop="handleUnreadNotification"
          data-testid="notification-mark-unread"
        >
          Mark as unread
        </div>
        <div
          class="modal-item"
          @click.stop="handleDeleteNotification"
          data-testid="notification-delete"
        >
          Delete
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps } from 'vue';
import { useStore } from 'vuex';

// ✅ Props
const props = defineProps({
	id: {
		type: [String, Number],
		required: true,
	},
	closeModal: {
		type: Function,
		required: true,
	},
});

// ✅ Vuex store
const store = useStore();

// ✅ Methods
const handleReadNotification = async () => {
	const data = { id: props.id, viewed: true };
	await store.dispatch('readNotification', data);
	await store.dispatch('loadNotifications');
	await store.dispatch('loadNotificationsCount');
	props.closeModal();

};

const handleUnreadNotification = async () => {
	const data = { id: props.id, viewed: false };
	await store.dispatch('setUnreadNotification', data);
	await store.dispatch('loadNotifications');
	await store.dispatch('loadNotificationsCount');
	props.closeModal();
};

const handleDeleteNotification = async () => {
	await store.dispatch('deleteNotification', props.id);
	await store.dispatch('loadNotifications');
	props.closeModal();
};
</script>

<style scoped>
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  position: absolute;
  right: 19px;
  top: 16px;
  z-index: 1001;
}

.modal-container {
  width: 155px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}

.modal-item {
  font-size: 14px;
  padding: 10px 20px;
  cursor: pointer;
}

.modal-item:not(:last-child) {
  border-bottom: 1px solid #F1F6FF;
}

.modal-item:hover {
  background-color: #F5F9FC;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
